// Carrousel d'avis : ordre fixe (celui du snippet), défilement fluide
// (aimantation douce, glisser-déposer à la souris avec inertie).
(function () {
  document.querySelectorAll('[data-mp-avisc-piste]').forEach(function (piste) {
    // Défilement infini : la série est répétée 3 fois et on reste dans la copie du milieu.
    // Dès qu'on s'en éloigne d'une demi-série, on se replace d'une série entière (invisible).
    var originales = Array.prototype.slice.call(piste.children);
    var copie = function () {
      originales.forEach(function (carte) {
        var clone = carte.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        piste.appendChild(clone);
      });
    };
    copie();
    copie();
    var largeurSerie = function () {
      return piste.children[originales.length].offsetLeft - piste.children[0].offsetLeft;
    };
    var recentrer = function () {
      var serie = largeurSerie();
      if (!serie) return 0;
      if (piste.scrollLeft < serie * 0.5) {
        piste.scrollLeft += serie;
        return serie;
      }
      if (piste.scrollLeft > serie * 1.5) {
        piste.scrollLeft -= serie;
        return -serie;
      }
      return 0;
    };
    piste.style.scrollSnapType = 'none';
    piste.scrollLeft = largeurSerie();
    piste.style.scrollSnapType = '';

    // Glisser à la souris (le tactile défile déjà nativement)
    var enGlisse = false;
    var departX = 0;
    var departScroll = 0;
    var vitesse = 0;
    var dernierX = 0;
    var inertie = null;

    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      enGlisse = true;
      departX = e.clientX;
      dernierX = e.clientX;
      departScroll = piste.scrollLeft;
      vitesse = 0;
      cancelAnimationFrame(inertie);
      piste.classList.add('is-glisse');
    });

    window.addEventListener('pointermove', function (e) {
      if (!enGlisse) return;
      vitesse = dernierX - e.clientX;
      dernierX = e.clientX;
      piste.scrollLeft = departScroll + (departX - e.clientX);
      departScroll += recentrer();
    });

    // Recentrage seulement une fois le défilement terminé : modifier scrollLeft pendant un
    // défilement tactile (élan iOS / Android) casse le geste et le rend saccadé
    var auDoigt = false;
    var attente = null;
    var recentrerAuRepos = function () {
      clearTimeout(attente);
      attente = setTimeout(function () {
        if (enGlisse || auDoigt) return;
        piste.style.scrollSnapType = 'none';
        recentrer();
        piste.style.scrollSnapType = '';
      }, 180);
    };
    piste.addEventListener('touchstart', function () {
      auDoigt = true;
      clearTimeout(attente);
    }, { passive: true });
    piste.addEventListener('touchend', function () {
      auDoigt = false;
      recentrerAuRepos();
    }, { passive: true });
    piste.addEventListener('touchcancel', function () {
      auDoigt = false;
      recentrerAuRepos();
    }, { passive: true });
    piste.addEventListener('scroll', function () {
      if (!enGlisse) recentrerAuRepos();
    }, { passive: true });

    window.addEventListener('pointerup', function () {
      if (!enGlisse) return;
      enGlisse = false;
      // Inertie : on prolonge le geste puis on laisse l'aimantation faire
      var freiner = function () {
        vitesse *= 0.94;
        piste.scrollLeft += vitesse;
        recentrer();
        if (Math.abs(vitesse) > 0.4) {
          inertie = requestAnimationFrame(freiner);
        } else {
          piste.classList.remove('is-glisse');
        }
      };
      inertie = requestAnimationFrame(freiner);
    });

    piste.addEventListener('click', function (e) {
      if (Math.abs(dernierX - departX) > 6) e.preventDefault();
    });
  });
})();
